<template>
  <div class="input-multiselect__input">
    <input
      :id="id"
      class="input-multiselect__checkbox"
      :class="{ 'input-multiselect__checkbox--is-disabled': disabled }"
      :name="context.name"
      :value="value"
      type="checkbox"
      :required="required"
      :aria-required="required"
      :disabled="disabled"
      :aria-disabled="disabled"
      :checked="checked"
      @change="onChange"
    />
    <label class="input-multiselect__button" :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  inject: ['context', 'onOptionChange', 'syncOption'],
  props: {
    value: {
      type: String,
    },
    isAllButton: {
      type: Boolean,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uuid: this.$uuid.v1(),
    };
  },
  computed: {
    checked() {
      return this.context.internalValue.includes(this.value);
    },
    id() {
      return `${this.context.id}-${this.value}`;
    },
  },
  watch: {
    isAllButton: 'sync',
  },
  mounted() {
    this.sync();
  },
  methods: {
    sync() {
      this.syncOption(this.uuid, {
        value: this.value,
        isAllButton: this.isAllButton,
      });
    },
    onChange(event) {
      const checked = event.target.checked;
      if (!checked) {
        // by default prevent removing
        // because it shall be handled via internalValue
        event.target.checked = true;
      }
      this.onOptionChange(this.value, checked);
    },
  },
};
</script>
